module.exports = __webpack_public_path__ + "static/media/bifoldDoor.33248cf6.png";